import { ObservableQuery } from '@apollo/client';
import { OrganisationMember } from '@ih/app/shared/apis/interfaces';

export class FindAllOrganisationsSuccess {
  public static readonly type =
    '[User/Organisations] FindAllOrganisationsSuccess';
  constructor(
    public readonly result: ObservableQuery.Result<{
      findAllOrganisationMembers: OrganisationMember[];
    }>,
  ) {}
}
